import { useContext, useEffect } from 'react';
import * as BsIcons from "react-icons/bs";
import * as FaIcons from "react-icons/fa";
import { Link } from 'react-router-dom';
import { ChannelsContext } from '../../../context/ChannelsContext';
import { ChannelSideBarContext } from '../../../context/Channels/ChannelSideBarContext';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { disableOrEnableButtonsSave, disableButtonSave } from "../Emissora/EmissoraUtil";
import { ImageSidebarWithFallback } from "../Image/ImageSidebarWithFallback"
import PropTypes from 'prop-types';

function Emissora() {
  const { channelsMenuTemp, setChannelsMenuTemp, changeEnableChannel, changeDisabledChannel, OrderSequency } = useContext(ChannelsContext)
  const { channelButtonEdit, setChannelButtonEdit, channelColorSaved, setChannelColorSaved, setButtonChannel } = useContext(ChannelSideBarContext);

  useEffect(() => {
  }, [channelColorSaved, channelButtonEdit]);

  useEffect(() => {
    disableButtonSave('buttonChannel', 'buttonChannelCancel', channelColorSaved, setChannelColorSaved, setButtonChannel, document);
  }, []);


  let channelDraggable = {
    enabled: null,
    disabled: null
  } 

  function removeChannel(id) {
    let catchIndex;
    channelDraggable.enabled = Array.from(channelsMenuTemp.enabled);
    setButtonChannel(true)
    setChannelButtonEdit(true);
    disableOrEnableButtonsSave('buttonChannel', 'buttonChannelCancel', false, document);

    channelDraggable.enabled.map((item, index) => {
      if (item.id === id) catchIndex = index
    });

    channelDraggable.enabled.splice(catchIndex, 1);

    channelDraggable.enabled.map((item, index) => {
      item.seq = index
    });

    OrderSequency(channelDraggable);
    changeDisabledChannel(id);
  }

  function addChannel(id) {
    setButtonChannel(true);
    setChannelButtonEdit(true);
    disableOrEnableButtonsSave('buttonChannel', 'buttonChannelCancel', false, document);
    changeEnableChannel(id);
  }

  function handleOnDragEnd(result) {
    setButtonChannel(true);
    setChannelButtonEdit(true);
    disableOrEnableButtonsSave('buttonChannel', 'buttonChannelCancel', false, document);
    channelDraggable.enabled = Array.from(channelsMenuTemp.enabled);
    channelDraggable.disabled = Array.from(channelsMenuTemp.disabled);
    const [reorderedItem] = channelDraggable.enabled.splice(result.source.index, 1);
    channelDraggable.enabled.splice(result.destination.index, 0, reorderedItem);

    channelDraggable.enabled.map((item, index) => {
      item.seq = index
    });

    setChannelsMenuTemp(channelDraggable);
    OrderSequency(channelDraggable);
  }
  function DraggableItem({ item, index, removeChannel }) {
    return (
      <Draggable key={item.id.toString()} draggableId={item.id.toString()} index={index}>
        {(provided) => (
          <Link to="#" className='link' key={"channel_link_praca" + item.id}>
            <div style={{ display: "grid" }}>
              <li data-testid={'channel_' + item.id} onClick={() => removeChannel(item.id)} 
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  removeChannel(item.id);
                }
              }}
              className='nav-text' 
              ref={provided.innerRef} 
              {...provided.draggableProps} >
                <div className='buttonDrag' {...provided.dragHandleProps}>
                  <FaIcons.FaBars />
                </div>
                <ImageSidebarWithFallback
                  key={item.id}
                  title={item.label}
                  src={item.icons.menuBitmap}
                  style={{ width: '30px', marginRight: '10px', marginLeft: '5px' }}
                  dataid={item.id}
                  showTitle={true}
                />
                <span className='iconChecked'>
                  <BsIcons.BsCheckLg />
                </span>
              </li>
            </div>
          </Link>
        )}
      </Draggable>
    );
  }

  DraggableItem.propTypes = {
    item: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      icons: PropTypes.shape({
        menuBitmap: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    index: PropTypes.number.isRequired,
    removeChannel: PropTypes.func.isRequired,
  };
  
  function DisabledChannelItem({ item, addChannel }) {
    return (
      <Link key={"channel_link_" + item.id} to="#" className='link'>
        <div style={{ display: "grid" }}>
          <li data-testid={'channel_' + item.id} value={item.id} key={item.id} onClick={() => addChannel(item.id)} className='nav-text' >
            <ImageSidebarWithFallback
              key={item.id}
              title={item.label}
              src={item.icons.menuBitmap}
              style={{ width: '30px', marginRight: '10px', marginLeft: '5px' }}
              dataid={item.id}
              showTitle={true}
            />
          </li>
        </div>
      </Link>
    );
  }

  DisabledChannelItem.propTypes = {
    item: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      icons: PropTypes.shape({
        menuBitmap: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    addChannel: PropTypes.func.isRequired,
  };

  return (
    <div data-testid="divEmissora" id="divEmissora" >
      <div data-testid="divEmissoraList" id="divEmissoraList" className='emissoraNavList'>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId='nav-menu-items-praca'>
            {(provided) => (
              <ul className='nav-menu-items-praca' style={{ marginBottom: '2px' }} {...provided.droppableProps} ref={provided.innerRef}>
                {channelsMenuTemp?.enabled?.map((item, index) => (
                  <DraggableItem item={item} index={index} removeChannel={removeChannel} />
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
        <ul className='nav-menu-items-praca'>
          {/* Disabled Channels */}
          {channelsMenuTemp?.disabled?.map((item, index) => (
            <DisabledChannelItem item={item} addChannel={addChannel} />
          ))}
        </ul>
      </div>
    </div>
  );

}
export default Emissora;